import { render } from "./mail-send.vue?vue&type=template&id=7ff0937b"
import script from "./mail-send.vue?vue&type=script&lang=js"
export * from "./mail-send.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__